"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable no-console */
var count = 0;
var callbacks = {};

var AppConnector = /*#__PURE__*/function () {
  function AppConnector() {
    _classCallCheck(this, AppConnector);
  }

  _createClass(AppConnector, null, [{
    key: "registerCallback",
    value: function registerCallback() {
      window.appCallback = function appCallback(id, err, result) {
        if (!callbacks[id]) return console.warn('No callback found');
        callbacks[id](err, result);
        delete callbacks[id];
      };

      window.appEventCallback = function appEventCallback(moduleName, eventName, params) {
        if (!window.App[moduleName]) return console.warn("Module ".concat(moduleName, " not found "));
        if (!window.App[moduleName].dispatchEvent) return console.warn("Module ".concat(moduleName, " is not an EventTarget"));
        window.App[moduleName].dispatchEvent(new CustomEvent(eventName, {
          detail: params
        }));
      };
    }
  }, {
    key: "call",
    value: function () {
      var _call = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(moduleName, moduleVersion, funcName, parameters) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(window.SGAppInfo.moduleInfo[moduleName].indexOf(moduleVersion) === -1)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Version not supported by the App');

              case 2:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  count++;
                  var id = count;
                  window.ReactNativeWebView.postMessage(JSON.stringify({
                    type: 'functionCall',
                    payload: {
                      funcName: funcName,
                      parameters: parameters,
                      id: id,
                      moduleName: moduleName,
                      moduleVersion: moduleVersion
                    }
                  }));

                  callbacks[id] = function (err, result) {
                    if (err) return reject(err);
                    resolve(result);
                  };
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function call(_x, _x2, _x3, _x4) {
        return _call.apply(this, arguments);
      }

      return call;
    }()
  }]);

  return AppConnector;
}();

AppConnector.registerCallback();
if (!window.App) window.App = {};

window.App.isAvailable = function () {
  return !!window.ReactNativeWebView;
};

window.AppConnector = AppConnector;